import { defineMessages } from 'react-intl';

const messages: {
	body: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	bodyWithoutHelpCenterName: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	cancel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	confirm: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	saving: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	cancel: {
		id: 'company-hub-common.finish-migration-review-modal.cancel',
		defaultMessage: 'Cancel',
		description: 'Button that closes the finish migration review later confirmation modal.',
	},
	confirm: {
		id: 'company-hub-common.finish-migration-review-modal.confirm',
		defaultMessage: 'Confirm',
		description: 'Button that confirms saving the migration review update as a draft.',
	},
	saving: {
		id: 'company-hub-common.finish-migration-review-modal.saving',
		defaultMessage: 'Saving changes',
		description:
			'Screen reader status announced while migration review changes are being saved before finishing later.',
	},
	body: {
		id: 'company-hub-common.finish-migration-review-modal.body',
		defaultMessage:
			'You’re about to leave the {helpCenterName} update. We’ll save your changes as a draft, but you’ll need to review them later for the update to go live.',
		description:
			'Explains that leaving this help center update saves it as a draft. The helpCenterName placeholder is replaced by the help center name.',
	},
	bodyWithoutHelpCenterName: {
		id: 'company-hub-common.finish-migration-review-modal.bodyWithoutHelpCenterName',
		defaultMessage:
			'You’re about to leave the help center update. We’ll save your changes as a draft, but you’ll need to review them later for the update to go live.',
		description:
			'Explains that leaving the unnamed default help center update saves it as a draft and requires a later review before it goes live.',
	},
	title: {
		id: 'company-hub-common.finish-migration-review-modal.title',
		defaultMessage: 'Finish review later',
		description: 'Title of the modal that confirms finishing a migration review later.',
	},
});

export default messages;
